<template>
  <div v-show="totalElements > 0" class="mb-4">
    <PColapsable>
      <template #title>
        <div class="titleColaps_ColapsableSalidasTable">
          <span class="cod-divisa-label">{{ divisa.codDivisa }}</span>
          <span class="divisa-total">{{ filterNumber(total, 2) }}</span>
        </div>
      </template>
      <SalidasTable
        :total.sync="total"
        :totalElements.sync="totalElements"
        :divisa="divisa"
        :modal="false"
        :params="params"
        :columns-config="columnsConfig"
        :isBCR="isBCR"
      />
    </PColapsable>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import SalidasTable from "./SalidasTable.vue";
import VueFilters from "@/vue-filters";
import { IDivisa } from "@/entities";
import { IColumnaResponse, IMovimientoParams } from "@/services";

@Component({
  components: { SalidasTable },
  mixins: [VueFilters],
})
export default class ColapsableSalidasTable extends Vue {
  @Prop({ required: true }) columnsConfig!: IColumnaResponse;
  @Prop({ required: true, default: null }) divisa!: IDivisa;
  @Prop({ required: false, default: null }) params!: IMovimientoParams;
  @Prop({ required: false, default: false }) isBCR!: boolean;

  collapsed = true;
  total = 0;
  totalElements = 0;
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.toggle-separator {
  border-top: solid 1px #e9e9e9;
}

.cod-divisa-label {
  margin-left: 5px;
  margin-right: 9px;
  font-size: 14px;
  font-weight: 300;
  color: var(--secundario-prosegur-claro);
}

.divisa-total {
  font-size: 14px;
  font-weight: bold;
  color: var(--secundario-prosegur-claro);
}
</style>
